module.exports = __webpack_public_path__ + "static/media/Boat.9f8537af.svg";